import { CountryPhoneInputValue } from 'antd-country-phone-input';

import {
  AnswerAlternativeCollectionFilterSet,
  AnswerAlternativeCollectionSerializer,
  AnswerTextCollectionFilterSet,
  AnswerTextCollectionSerializer,
  AttachmentCollectionInputSerializer,
  AttachmentCollectionSerializer,
  AttachmentDetailSerializer,
  CandidateCollectionFilterSet,
  CandidateCollectionInputSerializer,
  CandidateCollectionSerializer,
  CandidateCommentaryCollectionInputSerializer,
  CandidateCommentaryCollectionSerializer,
  CandidateDetailInputSerializer,
  CandidateDetailSerializer,
  CandidateDisabilityCollectionFilterSet,
  CandidateDisabilitySerializer,
  CandidateHistoryCollectionFilterSet,
  CandidateHistoryCollectionSerializer,
  CandidateRegisterFieldCollectionSerializer,
  CandidateSerializer,
  CandidateSourceOptionCollectionSerializer,
  CandidateTagCollectionInputSerializer,
  CandidateTagCollectionSerializer,
  CandidateTagDetailSerializer,
  EmailCommunicationCollectionFilterSet,
  EmailCommunicationCollectionInputSerializer,
  EmailCommunicationCollectionSerializer,
  EmailCommunicationDetailSerializer,
  EmailCommunicationTemplateCollectionFilterSet,
  EmailCommunicationTemplateCollectionInputSerializer,
  EmailCommunicationTemplateCollectionSerializer,
  EmailCommunicationTemplateDetailSerializer,
  GroupCollectionInputSerializer,
  GroupCollectionSerializer,
  GroupDetailInputSerializer,
  GroupDetailSerializer,
  ImportFileCollectionFilterSet,
  ImportFileCollectionSerializer,
  JobPostingCandidateHistorySerializer,
  JobPostingCollectionFilterSet,
  JobPostingCollectionInputSerializer,
  JobPostingCollectionSerializer,
  JobPostingDetailInputSerializer,
  JobPostingDetailSerializer,
  JobPostingRecruitmentProcessSerializer,
  KeyPairCollectionSerializer,
  KeyPairDetailInputSerializer,
  KeyPairDetailSerializer,
  MatchResultCollectionFilterSet,
  MatchResultCollectionSerializer,
  OAuth2ClientCollectionInputSerializer,
  OAuth2ClientCollectionSerializer,
  PermissionCollectionFilterSet,
  PermissionCollectionSerializer,
  PermissionDetailSerializer,
  QuestionAlternativeCollectionFilterSet,
  QuestionAlternativeCollectionSerializer,
  QuestionCollectionFilterSet,
  QuestionCollectionInputSerializer,
  QuestionCollectionSerializer,
  RecruiterCollectionFilterSet,
  RecruiterCollectionInputSerializer,
  RecruiterCollectionSerializer,
  RecruitmentProcessCollectionFilterSet,
  RecruitmentProcessCollectionInputSerializer,
  RecruitmentProcessCollectionSerializer,
  RecruitmentProcessDetailInputSerializer,
  RecruitmentProcessDetailSerializer,
  RequestJobPostingCollectionFilterSet,
  RequestJobPostingCollectionInputSerializer,
  RequestJobPostingCollectionSerializer,
  RequestJobPostingDetailInputSerializer,
  RequestJobPostingDetailSerializer,
  RequestJobPostingStageWithApproverSerializer,
  RequestJobPostingHistoryCollectionFilterSet,
  RequestJobPostingHistoryCollectionSerializer,
  RequestJobPostingTemplateCollectionInputSerializer,
  RequestJobPostingTemplateDetailInputSerializer,
  RequestJobPostingTemplateDetailSerializer,
  RequestJobPostingTemplateSerializer,
  RequestJobPostingUserCollectionFilterSet,
  RequestJobPostingUserCollectionInputSerializer,
  RequestJobPostingUserSerializer,
  SankhyaAdmissionCollectionFilterSet,
  SankhyaAdmissionCollectionInputSerializer,
  SankhyaAdmissionCollectionSerializer,
  SankhyaJobPostingCollectionInputSerializer,
  SankhyaJobPostingCollectionSerializer,
  SankhyaJobPostingDetailSerializer,
  SeniorityLevelSerializer,
  StaffUserCollectionInputSerializer,
  StaffUserCollectionSerializer,
  StaffUserDetailInputSerializer,
  StaffUserDetailSerializer,
  StageCollectionFilterSet,
  StageCollectionInputSerializer,
  StageCollectionSerializer,
  StageDetailInputSerializer,
  StageDetailSerializer,
  TestResultCollectionFilterSet,
  TestResultCollectionSerializer,
  UserCollectionFilterSet,
  UserCollectionInputSerializer,
  UserCollectionSerializer,
  UserDetailInputSerializer,
  UserDetailSerializer,
  VixtingAdmissionCollectionFilterSet,
  VixtingAdmissionCollectionSerializer,
  RecruitmentProcessUserVisualizationCollectionInputSerializer,
  RecruitmentProcessUserVisualizationDetailSerializer,
  RecruitmentProcessUserVisualizationCollectionSerializer,
  CandidateUserVisualizationCollectionSerializer,
  CandidateUserVisualizationCollectionInputSerializer,
  CandidateUserVisualizationDetailSerializer,
  RecruiterDetailSerializer,
  InterviewScriptTemplateCollectionSerializer,
  InterviewScriptTemplateCollectionInputSerializer,
  InterviewScriptTemplateDetailSerializer,
  InterviewScriptTemplateDetailInputSerializer,
  InterviewCollectionSerializer,
  InterviewCollectionInputSerializer,
  InterviewDetailInputSerializer,
  InterviewDetailSerializer,
  InterviewCollectionFilterSet,
  InterviewScriptTemplateCollectionFilterSet,
  VixtingAdmissionLogCollectionSerializer,
  VixtingAdmissionDetailSerializer,
  VixtingAdmissionLogCollectionFilterSet,
  VixtingRequestJobPostingCollectionSerializer,
  RegistrationTemplateCollectionSerializer,
  RegistrationTemplateCollectionInputSerializer,
  RegistrationTemplateDetailSerializer,
  RegistrationTemplateDetailInputSerializer,
} from './api';
import { Branded } from './branded';

export type UUID = string;

export type SerialID = number;

export type PickType<Source, Condition> = Pick<
  Source,
  {
    [K in keyof Source]: K extends string | number
      ? Source[K] extends Condition
        ? K
        : never
      : never;
  }[keyof Source]
>;

//#region Email communication

export interface EmailCommunicationCollection extends EmailCommunicationCollectionSerializer {
  candidate: ReturnType<typeof CandidateId>;
  job_posting: ReturnType<typeof JobPostingId> | null;
}

export interface EmailCommunicationDetail extends EmailCommunicationDetailSerializer {
  candidate: ReturnType<typeof CandidateId>;
  job_posting: ReturnType<typeof JobPostingId> | null;
}

export interface EmailCommunicationCollectionParams extends EmailCommunicationCollectionFilterSet {
  candidate?: ReturnType<typeof CandidateId>;
  job_posting?: ReturnType<typeof JobPostingId>;
}

export type EmailCommunicationTemplateCollection = EmailCommunicationTemplateCollectionSerializer;

export type EmailCommunicationTemplateDetail = EmailCommunicationTemplateDetailSerializer;

export type EmailCommunicationTemplateCollectionParams =
  EmailCommunicationTemplateCollectionFilterSet & PaginationParams & SearchParams & OrderingParams;

export type EmailCommunicationTemplateCollectionData =
  EmailCommunicationTemplateCollectionInputSerializer;

export type AttachmentCollection = AttachmentCollectionSerializer;

export type AttachmentDetail = AttachmentDetailSerializer;

export type AttachmentCollectionData = AttachmentCollectionInputSerializer;

//#endregion

export interface TenantConfigurations {
  businessName: string;
  companyName: string;
  companyDescription: string;
  companySiteUrl: string;
  companyCNPJ: string;
  companyFromName: string;
  companyLogoUrl: string | null;
  companyLogoPreviewUrl: string | null;
  companyWelcomeMessageTemplateId?: number;
  enablePublicationNetvagasJobboard: boolean;
  enableLinkedinIntegration: boolean;
  enableIndeedIntegration: boolean;
  enableSideMenu: boolean;
  enableAlchemerIntegration: boolean;
  alchemerTeamID: string;
  linkedinIndustryCode: number;
  linkedinCompanyId: number;
  linkedinPosterEmail: string;
  careerPageButtonColor: string;
  careerPageButtonTextColor: string;
  enableSankhyaAdmission: boolean;
  sankhyaClientToken: string;
  enableExternalApiIntegration: boolean;
  enableVixtingAdmission: boolean;
  enableVixtingUnitBusiness: boolean;
  vixtingMainCompanyToken: string;
  vixtingDaysToAdmission: number;
  vixtingAdmissionDateReference: 'admission_date' | 'current_date';
  enableAntivirusVerification: boolean;
  enableGenerateJobpostingDescription: boolean;
  enableGenerateRejectionFeedback: boolean;
  enableCareerjetIntegration: boolean;
  enableJoobleIntegration: boolean;
  t001_enableCentralizedAuthIntegration: boolean;
  t003_enableAutomaticEmailWhenCreateUser: boolean;
  t004_enableCentralEventJournal: boolean;
  t008_enableWhatsAppSubscription: boolean;
  defaultRegistrationTemplateId: number | null;
  enableCandidateResumeSummary: boolean;
  enableGenerateInterviewScript: boolean;
  enableFileProcessingWithSearchEngine: boolean;
  enableAttachmentSearchForTalentPool: boolean;
  showAttachmentContent: boolean;
  enableCompetencyGeneration: boolean;
  candidateResumeSummaryCallLimit: number;
  candidateResumeSummaryCounter: number;
  candidateResumeSummaryPlacement: 'CANDIDATE_ATTACHMENT' | 'CANDIDATE_DETAILS' | 'BOTH_TABS';
  enableGenerateScreeningQuestions: boolean;
  enableGeneratePracticalTechnicalCase: boolean;
  enableAuthSyncReplica: boolean;
  enableNexaAssessment: boolean;
  t007_enableChangeLanguage: boolean;
  enableReportViaStreaming: boolean;
  t009_subscriptionTemplates: boolean;
  t010_enableNewApproverProfile: boolean;
  t011_enableExternalApiHiredCandidateComplement: boolean;
  sankhyaUseOauth2Login: boolean;
  t012_showJobPostingsAndOpportunitiesStats: boolean;
}

export interface ReportCollectionData {
  type: 'APPLICATIONS' | 'REQUEST_JOB_POSTING';
}

interface Report {
  id: SerialID;
  type: 'APPLICATIONS' | 'REQUEST_JOB_POSTING';
  csv: string | null;
  xlsx: string | null;
  status: 'IN_PROGRESS' | 'SUCCESS' | 'FAILED';
  created_at: string;
  updated_at: string;
}

export type ReportCollection = Report;

export type CandidateRegisterFieldCollection = CandidateRegisterFieldCollectionSerializer;

export type CandidateSourceOptionCollection = CandidateSourceOptionCollectionSerializer;

export type CandidateTagCollection = CandidateTagCollectionSerializer;

export type CandidateTagDetail = CandidateTagDetailSerializer;

export type CandidateTagCollectionData = CandidateTagCollectionInputSerializer;

export interface CandidateTagCollectionParams extends EmailCommunicationCollectionFilterSet {
  candidate?: ReturnType<typeof CandidateId>;
  job_posting?: ReturnType<typeof JobPostingId>;
}

//#region Mindmatch

export interface MindmatchExternalResultLabeledScore {
  value: number;
  label: string;
}

export interface MindmatchExternalResultScore {
  [name: string]: number | MindmatchExternalResultLabeledScore;
}

export interface MindmatchAttributes {
  name: string;
  value: number;
}

//#endregion

//#region Mindsight

export interface MindsightPaginatedResponse<T> {
  next?: string;
  previous?: string;
  results: T[];
}

interface MindsightRequiredAssessment {
  key: string;
  recruiter_name: string;
}

export interface MindsightFunction {
  id: number;
  name: string;
  required_assessments: MindsightRequiredAssessment[];
}

//#endregion

export interface PaginatedResponse<T> {
  count: number;
  next?: string;
  previous?: string;
  results: T[];
}

export type UserCollection = UserCollectionSerializer;

export type UserCollectionParams = UserCollectionFilterSet & SearchParams & PaginationParams;

export type UserCollectionData = UserCollectionInputSerializer;

export type UserDetail = UserDetailSerializer;

export type UserDetailData = UserDetailInputSerializer;

export type StaffUserCollection = StaffUserCollectionSerializer;

export type StaffUserDetail = StaffUserDetailSerializer;

export type StaffUserCollectionData = StaffUserCollectionInputSerializer;

export type StaffUserDetailData = StaffUserDetailInputSerializer;

export type GroupCollection = GroupCollectionSerializer;

export type GroupCollectionParams = PaginationParams;

export type GroupCollectionData = GroupCollectionInputSerializer;

export type GroupDetail = GroupDetailSerializer;

export type GroupDetailData = GroupDetailInputSerializer;

export type RegistrationTemplateCollection = RegistrationTemplateCollectionSerializer;

export type RegistrationTemplateCollectionParams = PaginationParams;

export type RegistrationTemplateCollectionData = RegistrationTemplateCollectionInputSerializer;

export type RegistrationTemplateDetail = RegistrationTemplateDetailSerializer;

export type RegistrationTemplateDetailData = RegistrationTemplateDetailInputSerializer;

export type PermissionCollection = PermissionCollectionSerializer;

export type PermissionCollectionParams = PermissionCollectionFilterSet;

export type PermissionDetail = PermissionDetailSerializer;

export type RecruiterDetail = RecruiterDetailSerializer;

//#region APM types

export interface PayloadErrorAPM {
  id: string;
  culprit: string;
  exception: {
    message: string;
    stacktrace: unknown[];
    type: string;
  };
  context: unknown;
  trace_id: string;
  parent_id: string;
  transaction_id: string;
  transaction: {
    type: unknown;
    sampled: boolean;
  };
}

//#endregion

//#region Alchemer

export interface PaginationParams {
  page?: number;
  page_size?: number;
}

interface SearchParams {
  search?: string;
}

interface ExpandableParams {
  expand?: string;
}

interface OrderingParams {
  ordering?: string;
}

export interface AlchemerPaginatedResponse<T> {
  data: T[];
  page: number;
  results_per_page: number;
  total_count: number;
  total_pages: number;
}

export interface SurveyListObjectParams {
  'filter[field][1]': 'status';
  'filter[operator][1]': '=';
  'filter[value][1]': 'launched';
}

export interface SurveyListObject {
  id: number;
  links: {
    default: string;
    edit: string;
    publish: string;
  };
  statistics: {
    Complete: number;
  } | null;
  status: string;
  title: string;
}

export interface SurveyOptions {
  [k: number]: {
    id: number;
    option: string;
    answer: string;
  };
}

export interface SurveyResponseListParams {
  'filter[field][1]': '[url("sguid")]';
  'filter[operator][1]': '=';
  'filter[value][1]': UUID;
}

export interface SurveyResponseList {
  id: number;
  session_id?: string;
  link_id?: number;
  contact_id?: string;
  status: 'Complete' | 'Partial' | 'Disqualified';
  date_submitted: string;
  response_time: number;
  survey_data: {
    [k: number]: {
      id: number;
      question: string;
      section_id: number;
      shown: boolean;
      type: string;
      answer?: string;
      answer_id?: number;
      options?: SurveyOptions;
    };
  };
}

export interface SurveyQuestion {
  id: number;
  options: {
    id: number;
    title: {
      [k: string]: string;
    };
    value: string;
  }[];
  properties: {
    map_key: string;
  };
  title: {
    [k: string]: string;
  };
  type: string;
}

interface SurveyPage {
  id: number;
  questions: SurveyQuestion[];
}

export interface Survey {
  id: number;
  title: string;
  links: {
    default: string;
  };
  pages: SurveyPage[];
  statistics: {
    Complete: number;
  } | null;
  status: string;
}

export interface QuestionCollection extends QuestionCollectionSerializer {
  job_posting: ReturnType<typeof JobPostingId>;
}

export interface QuestionCollectionData extends QuestionCollectionInputSerializer {
  job_posting: ReturnType<typeof JobPostingId>;
}

export type QuestionAlternativeCollection = QuestionAlternativeCollectionSerializer;

export function RecruitmentProcessId(value: unknown) {
  return Number(value) as Branded<number, 'RecruitmentProcessId'>;
}

export function VixtingAdmissionId(value: unknown) {
  return Number(value) as Branded<number, 'VixtingAdmissionId'>;
}

export interface RecruitmentProcessCollection extends RecruitmentProcessCollectionSerializer {
  id: ReturnType<typeof RecruitmentProcessId>;
  candidate: CandidateSerializer & { id: ReturnType<typeof CandidateId> };
  job_posting: JobPostingRecruitmentProcessSerializer & { id: ReturnType<typeof JobPostingId> };
}

export interface RecruitmentProcessDetail extends RecruitmentProcessDetailSerializer {
  id: ReturnType<typeof RecruitmentProcessId>;
  candidate: CandidateSerializer & {
    id: ReturnType<typeof CandidateId>;
  };
  job_posting: ReturnType<typeof JobPostingId>;
}

export interface RecruitmentProcessCollectionData
  extends RecruitmentProcessCollectionInputSerializer {
  candidate: ReturnType<typeof CandidateId>;
  job_posting: ReturnType<typeof JobPostingId>;
}

export interface RecruitmentProcessDetailCustomData {
  stage: StageDetail['id'];
}

export interface RecruitmentProcessDetailHireData {
  admission_date: string;
  salary: number;
}

export interface RecruitmentProcessCollectionParams
  extends RecruitmentProcessCollectionFilterSet,
    PaginationParams,
    OrderingParams {
  candidate?: ReturnType<typeof CandidateId>;
  job_posting?: ReturnType<typeof JobPostingId>;
}

export interface RecruitmentProcessesActionsSelectAllCollectionData {
  job_posting: ReturnType<typeof JobPostingId>;
}

export type RecruitmentProcessesActionsCollectionParams = RecruitmentProcessCollectionFilterSet &
  SearchParams;

export interface RecruitmentProcessesActionsAllCollection {
  message: string;
}

export interface RecruitmentProcessesActionsRejectAllCollectionData
  extends Partial<
    Omit<EmailCommunicationCollectionInputSerializer, 'candidate' | 'job_posting' | 'type'>
  > {
  commentary: string;
}

export type RecruitmentProcessesActionsSendEmailToAllCollectionData = Omit<
  EmailCommunicationCollectionInputSerializer,
  'candidate'
>;

export interface RecruitmentProcessesActionsMoveStageAllCollectionData {
  stage: StageCollectionSerializer['id'];
}

export interface MatchResultCollection extends MatchResultCollectionSerializer {
  recruitment_process: ReturnType<typeof RecruitmentProcessId> | null;
  candidate: ReturnType<typeof CandidateId>;
}

export interface MatchResultCollectionParams
  extends MatchResultCollectionFilterSet,
    PaginationParams {
  candidate?: ReturnType<typeof CandidateId>;
  recruitment_process?: ReturnType<typeof RecruitmentProcessId>;
}

export interface TestResultCollection extends TestResultCollectionSerializer {
  secondary_score: MindmatchExternalResultScore | MindmatchAttributes[];
  recruitment_process: ReturnType<typeof RecruitmentProcessId> | null;
  candidate: ReturnType<typeof CandidateId>;
}

export interface TestResultCollectionParams
  extends TestResultCollectionFilterSet,
    PaginationParams {
  candidate?: ReturnType<typeof CandidateId>;
  recruitment_process?: ReturnType<typeof RecruitmentProcessId>;
}

//#endregion

//#region Recrutamento

export type RecruiterCollection = RecruiterCollectionSerializer;

export interface RecruiterCollectionParams extends RecruiterCollectionFilterSet, PaginationParams {
  job_posting_id?: ReturnType<typeof JobPostingId>;
}

export interface RecruiterCollectionData extends RecruiterCollectionInputSerializer {
  job_posting: ReturnType<typeof JobPostingId>;
}

export function JobPostingId(value: unknown) {
  return Number(value) as Branded<number, 'JobPostingId'>;
}

export interface JobPostingCollection extends JobPostingCollectionSerializer {
  id: ReturnType<typeof JobPostingId>;
}

export type JobPostingCollectionParams = JobPostingCollectionFilterSet &
  PaginationParams &
  SearchParams &
  ExpandableParams;

export type JobPostingCollectionData = JobPostingCollectionInputSerializer;

export interface JobPostingDetail extends JobPostingDetailSerializer {
  id: ReturnType<typeof JobPostingId>;
}

export interface JobPostingCandidateStageCountParams {
  candidate_status?: 'ACTIVE' | 'INACTIVE' | 'GIVEN_UP';
}

export interface JobPostingCandidateStageCount {
  id: Branded<number, 'StageId'>;
  name: string;
  sequence: number;
  candidate_count: number;
}

export type JobPostingStatisticsParams = JobPostingCollectionFilterSet & SearchParams;

export interface JobPostingStatistics {
  total: number;
  in_progress: number;
  overdue: number;
  published: number;
}

export type JobPostingDetailData = JobPostingDetailInputSerializer;

export interface ExtendedCountryPhoneInputValue {
  id?: SerialID;
  phoneNumber: CountryPhoneInputValue;
  phoneType:
    | 'PERSONAL'
    | 'RESIDENTIAL'
    | 'PROFESSIONAL'
    | 'MOBILE'
    | 'BUSINESS_FAX'
    | 'PERSONAL_FAX'
    | 'OTHER';
}

export function CandidateId(value: unknown) {
  return Number(value) as Branded<number, 'CandidateId'>;
}

export interface CandidateCollection extends CandidateCollectionSerializer {
  id: ReturnType<typeof CandidateId>;
}

export interface CandidateDetail extends CandidateDetailSerializer {
  id: ReturnType<typeof CandidateId>;
}

export type CandidateCollectionData = CandidateCollectionInputSerializer;

export type CandidateCollectionParams = CandidateCollectionFilterSet &
  PaginationParams &
  OrderingParams;

export type CandidateDetailData = CandidateDetailInputSerializer;

export interface CandidateHistoryCollection extends CandidateHistoryCollectionSerializer {
  candidate: ReturnType<typeof CandidateId>;
  job_posting: JobPostingCandidateHistorySerializer & { id: ReturnType<typeof JobPostingId> };
}

export interface CandidateDisabilityCollection extends CandidateDisabilitySerializer {
  candidate: ReturnType<typeof CandidateId>;
}

export interface CandidateHistoryCollectionParams
  extends CandidateHistoryCollectionFilterSet,
    PaginationParams {
  candidate?: ReturnType<typeof CandidateId>;
  job_posting?: ReturnType<typeof JobPostingId>;
}

export interface CandidateDisabilityCollectionParams
  extends CandidateDisabilityCollectionFilterSet,
    PaginationParams {
  candidate?: ReturnType<typeof CandidateId>;
}

export interface CandidatesActionsSelectAllCollectionData {
  job_posting: ReturnType<typeof JobPostingId>;
}

export type CandidatesActionSendEmailToAllCollectionData = Omit<
  EmailCommunicationCollectionInputSerializer,
  'candidate'
>;

export type CandidatesActionsCollectionParams = CandidateCollectionFilterSet & SearchParams;

export interface CandidatesActionsCollection {
  message: string;
}

export type CandidateCommentaryCollection = CandidateCommentaryCollectionSerializer;

export interface CandidateCommentaryCollectionData
  extends CandidateCommentaryCollectionInputSerializer {
  candidate: ReturnType<typeof CandidateId>;
}

export interface StageCollection extends StageCollectionSerializer {
  job_posting: ReturnType<typeof JobPostingId>;
}

export interface ExpandedStageCollection
  extends Omit<StageCollection, 'email_communication_template'> {
  email_communication_template: EmailCommunicationTemplateDetailSerializer | null;
}

export type StageCollectionData = StageCollectionInputSerializer;

export interface StageDetail extends StageDetailSerializer {
  job_posting: ReturnType<typeof JobPostingId>;
}

export type StageDetailData = StageDetailInputSerializer;

export type SeniorityLevelCollectionData = SeniorityLevelSerializer;

export type RecruitmentProcessDetailData = RecruitmentProcessDetailInputSerializer;

export interface AnswerTextCollection extends AnswerTextCollectionSerializer {
  recruitment_process: ReturnType<typeof RecruitmentProcessId>;
}

export interface AnswerAlternativeCollection extends AnswerAlternativeCollectionSerializer {
  recruitment_process: ReturnType<typeof RecruitmentProcessId>;
}

export interface AnswerTextCollectionParams
  extends AnswerTextCollectionFilterSet,
    PaginationParams {
  recruitment_process?: ReturnType<typeof RecruitmentProcessId>;
}

export interface AnswerAlternativeCollectionParams
  extends AnswerAlternativeCollectionFilterSet,
    PaginationParams {
  recruitment_process?: ReturnType<typeof RecruitmentProcessId>;
}

export interface QuestionCollectionParams extends QuestionCollectionFilterSet, PaginationParams {
  job_posting_id?: ReturnType<typeof JobPostingId>;
}

export interface QuestionAlternativeCollectionParams
  extends QuestionAlternativeCollectionFilterSet,
    PaginationParams {
  question__job_posting_id?: ReturnType<typeof JobPostingId>;
}

export interface StageCollectionParams
  extends StageCollectionFilterSet,
    PaginationParams,
    ExpandableParams {
  job_posting_id?: ReturnType<typeof JobPostingId>;
}

export type StageDetailParams = ExpandableParams;

//#endregion

export type OAuth2ClientCollection = OAuth2ClientCollectionSerializer;

export type OAuth2ClientCollectionData = OAuth2ClientCollectionInputSerializer;

export type KeyPairCollection = KeyPairCollectionSerializer;
export type KeyPairDetail = KeyPairDetailSerializer;

export type KeyPairCollectionParams = PaginationParams & SearchParams;

export type KeyPairDetailData = KeyPairDetailInputSerializer;

//#region Sankhya

export interface SankhyaCompany {
  CODEMP?: string;
  Empresa_NOMEFANTASIA?: string;
}
export interface SankhyaJobRole {
  CODCARGO?: string;
  DESCRCARGO?: string;
  ATIVO?: string;
}

export interface SankhyaDepartment {
  CODDEP?: string;
  DESCRDEP?: string;
  ATIVO?: string;
  ANALITICO?: string;
}

export interface SankhyaEntityCollectionParams {
  offsetPage?: string;
  fieldsetList?: string;
  joinFieldsetList?: string;
  filter?: { [k: string]: string };
  sort?: string;
}

export interface SankhyaAdmissionCollectionData extends SankhyaAdmissionCollectionInputSerializer {
  recruitment_process: ReturnType<typeof RecruitmentProcessId>;
  admission_type?: string;
  limit_date?: string;
}

export interface SankhyaJobPostingCollection extends SankhyaJobPostingCollectionSerializer {
  job_posting: ReturnType<typeof JobPostingId>;
}

export interface SankhyaJobPostingDetail extends SankhyaJobPostingDetailSerializer {
  job_posting: ReturnType<typeof JobPostingId>;
}

export interface SankhyaJobPostingCollectionParams extends PaginationParams {
  job_posting_id?: ReturnType<typeof JobPostingId>;
}

export interface SankhyaJobPostingCollectionData
  extends SankhyaJobPostingCollectionInputSerializer {
  job_posting: ReturnType<typeof JobPostingId>;
}

export interface SankhyaJobPostingDetailData extends SankhyaJobPostingDetailSerializer {
  job_posting: ReturnType<typeof JobPostingId>;
}

export interface SankhyaAdmissionCollection extends SankhyaAdmissionCollectionSerializer {
  recruitment_process: ReturnType<typeof RecruitmentProcessId>;
}

export interface SankhyaAdmissionCollectionParams
  extends PaginationParams,
    SankhyaAdmissionCollectionFilterSet {
  recruitment_process?: ReturnType<typeof RecruitmentProcessId>;
}
export interface VixtingEntityCollectionParams {
  page?: string;
  company_id?: string;
}
export interface VixtingCompanyEntityCollectionParams {
  page?: string;
  is_active: boolean;
}

//#endregion

//#region Vixting
export interface VixtingCompany {
  id: string;
  name?: string;
  fantasyName?: string;
  is_active?: boolean;
  token?: string;
  created_at?: string;
  updated_at?: string;
}

export interface VixtingAffiliate {
  id: string;
  companyParentId: string;
  fantasyName?: string;
}

export interface VixtingDepartment {
  id: string;
  name?: string;
}

export interface VixtingJobRole {
  id: string;
  name?: string;
  linkToAllDepartment?: boolean;
  departments?: VixtingDepartment[];
}

export interface VixtingUnitBusiness {
  id: string;
  name?: string;
}

export interface VixtingJobPostingCollectionSerializer {
  id: number;
  job_posting: number;
  company: string;
  affiliate: string;
  job_role: string;
  unit_business: string;
  department: string;
  created_at: string;
  updated_at: string;
}

export interface VixtingJobPostingCollection extends VixtingJobPostingCollectionSerializer {
  job_posting: ReturnType<typeof JobPostingId>;
}

export interface VixtingJobPostingCollectionParams extends PaginationParams {
  job_posting_id?: ReturnType<typeof JobPostingId>;
}

export interface VixtingAdmissionCollection extends VixtingAdmissionCollectionSerializer {
  recruitment_process: ReturnType<typeof RecruitmentProcessId>;
}

export interface VixtingAdmissionCollectionParams
  extends PaginationParams,
    VixtingAdmissionCollectionFilterSet {
  recruitment_process?: ReturnType<typeof RecruitmentProcessId>;
}

export interface VixtingAdmissionDetail extends VixtingAdmissionDetailSerializer {
  id: ReturnType<typeof VixtingAdmissionId>;
}

export type VixtingAdmissionLogsCollection = VixtingAdmissionLogCollectionSerializer;

export type VixtingAdmissionLogsCollectionParams = PaginationParams &
  VixtingAdmissionLogCollectionFilterSet;

export interface VixtingRequestJobPostingCollection
  extends VixtingRequestJobPostingCollectionSerializer {
  request_job_posting: ReturnType<typeof RequestJobPostingId>;
}

export interface VixtingRequestJobPostingCollectionParams extends PaginationParams {
  request_job_posting_id?: ReturnType<typeof RequestJobPostingId>;
}

//#endregion

//#region Imports

export type ImportFileCollection = ImportFileCollectionSerializer;

export type ImportFileCollectionParams = PaginationParams &
  OrderingParams &
  ImportFileCollectionFilterSet;

//#endregion

interface RequestFileAccess {
  token_type: string;
  access_token: string;
}

export type RequestFileAccessDetail = RequestFileAccess;

export interface PermissionCodenames {
  view_all_vacancies: number;
  create_and_edit_vacancies: number;
  access_talent_pool: number;
  access_configurations: number;
  access_reports: number;
  view_marked_request_job_postings: number;
  view_all_request_job_postings: number;
  create_and_edit_request_job_postings: number;
  can_approve_marked_request_job_postings: number;
  can_approve_all_request_job_postings: number;
}

//#region InterviewScriptTemplate

export type InterviewScriptTemplateCollection = InterviewScriptTemplateCollectionSerializer;

export interface ExpandedInterviewScriptTemplateCollection
  extends Omit<InterviewScriptTemplateCollection, 'email_communication_template'> {
  email_communication_template: EmailCommunicationTemplateDetailSerializer | null;
}

export type InterviewScriptTemplateParams = PaginationParams &
  OrderingParams &
  InterviewScriptTemplateCollectionFilterSet &
  ExpandableParams;

export type InterviewScriptTemplateCollectionData =
  InterviewScriptTemplateCollectionInputSerializer;

export type InterviewScriptTemplateDetail = InterviewScriptTemplateDetailSerializer;
export type InterviewScriptTemplateDetailData = InterviewScriptTemplateDetailInputSerializer;

export type InterviewScriptTemplateTypeAllowed =
  | 'SCREENING_INTERVIEW'
  | 'HR_INTERVIEW'
  | 'MANAGER_INTERVIEW'
  | 'STAKEHOLDERS_INTERVIEW'
  | 'PRACTICAL_TECHNICAL_CASE';

//#endregion

//#region Interview

export type InterviewCollection = InterviewCollectionSerializer;

export type InterviewParams = PaginationParams & OrderingParams & InterviewCollectionFilterSet;

export type InterviewCollectionData = InterviewCollectionInputSerializer;

export type InterviewDetail = InterviewDetailSerializer;
export type InterviewDetailData = InterviewDetailInputSerializer;

export type InterviewHistoryChangedFields = {
  annotations?: string;
  opinion_status?: string;
  opinion_justification?: string;
};

//#endregion

//#region RequestJobPostingTemplate

export type RequestJobPostingTemplateCollection = RequestJobPostingTemplateSerializer;

export type RequestJobPostingTemplateParams = PaginationParams & OrderingParams;

export type RequestJobPostingTemplateCollectionData =
  RequestJobPostingTemplateCollectionInputSerializer;

export type RequestJobPostingTemplateDetail = RequestJobPostingTemplateDetailSerializer;
export type RequestJobPostingTemplateDetailData = RequestJobPostingTemplateDetailInputSerializer;

//#endregion

//#region RequestJobPosting

export function RequestJobPostingId(value: unknown) {
  return Number(value) as Branded<number, 'RequestJobPostingId'>;
}

export interface RequestJobPostingCollection extends RequestJobPostingCollectionSerializer {
  id: ReturnType<typeof RequestJobPostingId>;
}

export type RequestJobPostingCollectionData = RequestJobPostingCollectionInputSerializer;

export interface RequestJobPostingDetail extends RequestJobPostingDetailSerializer {
  id: ReturnType<typeof RequestJobPostingId>;
}

export type RequestJobPostingDetailData = RequestJobPostingDetailInputSerializer;

export type RequestJobPostingParams = PaginationParams &
  OrderingParams &
  SearchParams &
  RequestJobPostingCollectionFilterSet &
  ExpandableParams;

export type RequestJobPostingStatisticsParams = RequestJobPostingCollectionFilterSet & SearchParams;

export interface RequestJobPostingStatistics {
  in_progress: number;
  not_initiated: number;
}

export type RequestJobPostingStageWithApprover = RequestJobPostingStageWithApproverSerializer;

//#endregion

//#region RequestJobPostingStage

export type RequestJobPostingStageData = {
  comment: string;
};

//#endregion

//#region RequestJobPostingUser

export type RequestJobPostingUserCollection = RequestJobPostingUserSerializer;

export type RequestJobPostingUserCollectionData = RequestJobPostingUserCollectionInputSerializer;

export type RequestJobPostingUserParams = PaginationParams &
  OrderingParams &
  RequestJobPostingUserCollectionFilterSet;

//#endregion

//#region RequestJobPostingHistory

export type RequestJobPostingHistoryCollection = RequestJobPostingHistoryCollectionSerializer;

export type RequestJobPostingHistoryParams = PaginationParams &
  OrderingParams &
  RequestJobPostingHistoryCollectionFilterSet;

//#endregion

//#region RecruitmentProcessUserVisualization

export type RecruitmentProcessUserVisualizationCollection =
  RecruitmentProcessUserVisualizationCollectionSerializer;

export type RecruitmentProcessUserVisualizationCollectionData =
  RecruitmentProcessUserVisualizationCollectionInputSerializer;

export type RecruitmentProcessUserVisualizationDetail =
  RecruitmentProcessUserVisualizationDetailSerializer;

//#endregion

//#region CandidateUserVisualization

export type CandidateUserVisualizationCollection = CandidateUserVisualizationCollectionSerializer;

export type CandidateUserVisualizationCollectionData =
  CandidateUserVisualizationCollectionInputSerializer;

export type CandidateUserVisualizationDetail = CandidateUserVisualizationDetailSerializer;

//#endregion

//#region StageSubTypeChoices

export const StageSubTypeChoices = {
  SCREENING_INTERVIEW: 'Entrevista de screening',
  HR_INTERVIEW: 'Entrevista com RH',
  MANAGER_INTERVIEW: 'Entrevista com gestor(a)',
  STAKEHOLDERS_INTERVIEW: 'Entrevista com demais envolvidos',
  PRACTICAL_TECHNICAL_CASE: 'Case prático ou técnico',
  MINDSIGHT_TESTS: 'Testes Mindsight',
  CUSTOM_TEST: 'Teste customizado',
  GROUP_DYNAMICS: 'Dinâmica de grupo',
  COMMUNICATION: 'Comunicação',
  OTHERS: 'Outros',
  LEGACY: 'Legado',
} as const;

export type StageSubTypeKeys = keyof typeof StageSubTypeChoices;

//#region StageSubTypeChoices

//#region mindsightAuthToggles
export type MindsightAuthToggles = {
  t001_use_new_home_design: boolean;
  t004_hide_logout_sankhyarh: boolean;
  enable_sankhya_menu: boolean;
};

//#region mindsightAuthToggles

//#region RegistrationTemplateTypes

export type RegistrationFields = Omit<
  RegistrationTemplateDetail,
  'id' | 'name' | 'created_at' | 'updated_at'
>;

export type RegistrationFieldType = 'VISIBLE' | 'VISIBLE_AND_REQUIRED' | 'NOT_VISIBLE';

export type AlwaysVisibleRegistrationFieldType = 'REQUIRED' | 'NOT_REQUIRED';

//#endregion
